// Add your custom JS here.

// if (document.getElementById("terms-click")) {
//   document.getElementById("terms-click").addEventListener("click", () => {
//     document.querySelector(".accordion-button").classList.remove("collapsed");
//     document.getElementById("collapseOne").classList.add("show");
//     document
//       .querySelector(".accordion-button")
//       .setAttribute("aria-expanded", "true");
//   });
// }

document.addEventListener("DOMContentLoaded", function () {
  const ball = document.getElementById("ball");
  const ballImg = document.getElementById("sized-up");
  const inputField = document.getElementById("location");
  const holder = document.getElementById("holder");

  function getCoordinates(e) {
    const rect = ballImg.getBoundingClientRect();
    const coordinates = [e.clientX - rect.left, e.clientY - rect.top];
    return coordinates;
  }

  function placeBall(coord) {
    //elements we need

    const coordinates = coord;
    const imgHeight = ballImg.clientHeight;
    const imgWidth = ballImg.clientWidth;

    //placeImage of ball

    var heightPer = parseFloat(((coordinates[1] / imgHeight) * 100).toFixed(2));
    var widthPer = parseFloat(((coordinates[0] / imgWidth) * 100).toFixed(2));
    ball.style.top = heightPer + "%";
    ball.style.left = widthPer + "%";
    inputField.value = widthPer + "%, " + heightPer + "%";
    console.log(inputField);
  }

  function setHolderSize() {
    const imgHeight = ballImg.clientHeight;
    holder.style.height = imgHeight + "px";
    console.log(imgHeight);
  }
  if ((ballImg != null) | (ballImg != undefined)) {
    setHolderSize();

    window.addEventListener(
      "resize",
      function (event) {
        setHolderSize();
      },
      true
    );

    document.getElementById("sized-up").addEventListener("click", (e) => {
      const coordinates = getCoordinates(e);
      placeBall(coordinates);
      console.log(coordinates);
    });
  }

  if (document.getElementById("terms-click")) {
    document.getElementById("terms-click").addEventListener("click", () => {
      document.querySelector(".accordion-button").classList.remove("collapsed");
      document.getElementById("flush-collapseOne").classList.add("show");
      document
        .querySelector(".accordion-button")
        .setAttribute("aria-expanded", "true");
    });
  }
});

var swiper = new Swiper(".mySwiper", {
  spaceBetween: 30,
  centeredSlides: true,
  slidesPerView: 1,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
  },
});

AOS.init();
